import { type AbstractChatClient } from 'shared/clients/abstractChatClient';
import { MessageEventService } from 'shared/services/messageEventService';
import { type CustomEventData, type DataPayload } from 'types/customEventData';
import { getElementByIdAs } from 'utils/domHelpers';

const SUPPORT_IFRAME_ID = 'support-iframe';

export abstract class BaseChatService<TClient extends AbstractChatClient> {
  protected zendeskClient: TClient;

  protected constructor(client: TClient) {
    this.zendeskClient = client;
  }

  async initiateChat(payload?: Partial<DataPayload>): Promise<void> {
    await this.zendeskClient.setConversationMetadata({
      tags: payload?.tags,
      conversationFields: payload?.conversation_fields,
    });

    this.zendeskClient.openWidget();

    const messageEventService = MessageEventService.getInstance();

    const eventPayload: CustomEventData = {
      type: 'openChatSuccess',
    };

    const iFrame = getElementByIdAs<HTMLIFrameElement>(SUPPORT_IFRAME_ID);

    if (iFrame?.contentWindow) {
      // Notify iframe that chat has been opened
      messageEventService.postMessage(iFrame?.contentWindow, eventPayload);
    }

    // Notify parent window that chat has been opened
    messageEventService.postMessage(window, eventPayload);
  }
}
